import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { DatabaseCacheService } from '../cache/database-cache.service';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class GetRecordsWithFilesSizeService {

  constructor(
    private httpClient: HttpClient,
    private common: DatabaseCacheService,
    private msalService: MsalService,
  ) { }

  getRecordsWithFilesSize(params) {
    let sectionId = this.common.getSelectedSection().sectionId;
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    headers = headers
      .set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/RecordsWithFilesSizeGet`,  { headers: headers, params : params } );
  }

}
